import { sortBy } from "lodash";
import { ISelectOption } from "shared/models";

export const UtilityPrograms: ISelectOption[] = sortBy(
  [
    {
      label: "JCPL (NJ)",
      value: "JCPL (NJ)",
    },
    {
      label: "PSEG (NJ)",
      value: "PSEG (NJ)",
    },
    {
      label: "NJNG (NJ)",
      value: "NJNG (NJ)",
    },
    {
      label: "O&R (NJ)",
      value: "O&R (NJ)",
    },
    {
      label: "ConEd (NY)",
      value: "ConEd (NY)",
    },
    {
      label: "Eversource (CT)",
      value: "Eversource (CT)",
    },
    {
      label: "ACE (NJ)",
      value: "ACE (NJ)",
    },
    {
      label: "TBD",
      value: "TBD",
    },
  ],
  (o) => o.label
);
